import { createSlice } from '@reduxjs/toolkit';
import initialState from './state';

const slice = createSlice({
  name: 'AnalyticsPageReducer',
  initialState,
  reducers: {
    resetState: () => initialState,
    // Add analytics reducers as needed
  },
});

export default slice;
